import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { comingSoon } from '../../../assets/images';
import Modal, { setSelectedModal } from '../Modal';
import { setSelectedDrawer } from '../Drawer';

const MODAL_TIMEOUT = 5000;

const ComingSoonModal = () => {
    const dispatch = useDispatch();

    const handleClose = useCallback(() => dispatch(setSelectedModal(null)), [dispatch]);

    const footer = (
        <div className="p-4 flex align-center justify-center">
            <button
                type="button"
                className="btn mt-10 btn-primary mr-1"
                onClick={handleClose}
            >
                Close
            </button>
        </div>
    );

    useEffect(() => {
        dispatch(setSelectedDrawer(null));
        const ComingSoonModalTimer = setTimeout(handleClose, MODAL_TIMEOUT);
        return () => clearTimeout(ComingSoonModalTimer);
    }, [handleClose, dispatch]);

    return (
        <Modal
            footer={footer}
            handleClose={handleClose}
        >
            <div className="flex flex-col items-center">
                <img src={comingSoon} alt="coming-soon" className="mb-2 w-20 mt-12 invert" />
                <h2 className="text-center font-bold text-white">COMING SOON...</h2>
                <p className="text-center font-bold text-white text-lg my-2">Get ready for an amazing experience! 🚀</p>
                <p className="text-center font-bold text-lg text-white mb-2">Exciting updates are in progress and will be here soon. 🎉</p>
            </div>
        </Modal>
    );
};

export default ComingSoonModal;
